export default "__VITE_ASSET__613IZ7c$__"